import { css } from '@emotion/css';

import { AlignItems, Color, Display, Font, ScreenBreakpoint, Spacing, TextAlign } from '../../../styles';

export const bcLink = css`
  width: fit-content;
  ${Display.flex}
  ${AlignItems.center}
  text-decoration: none;
  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    ${Spacing.ml0}
  }
`;

export const label = css`
  ${Font.lg}
  ${TextAlign.left}
  color: ${Color.Brand6};
  ${Spacing.ml20}
  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    ${Spacing.ml8}
  }
`;

export const backArrow = css`
  ${Font.lg}
  color: ${Color.Brand6};
`;
